module.exports = __webpack_public_path__ + "static/media/info-03.e2cb664b.svg";